import { isFloat } from '@front-app/components/form/validation/validators';
import {
	EventPrice,
	EventCurrency,
	NonValidEventPrice,
	PriceOption,
	UpsertEventMeetingButton,
} from '@front-app/services/EventsApi/EventModel';
import { isNullish } from '@front-app/util/types';
import { isEnum } from '@front-app/util/enum';
import { ValidationRule } from '@front-app/components/form/validation/useValidation';

export const EMPTY_URL = 'https://';

export const numericValueValidator = isFloat(2);

export function isValidEventPrice(_: NonValidEventPrice | EventPrice): _ is EventPrice {
	if (_.type === PriceOption.VALUE) {
		if ((isNullish(_.numericValue) || _.numericValue === '') || !isEnum(_.currency, EventCurrency)) {
			return false;
		}
		if (typeof _.numericValue === 'string') {
			return numericValueValidator.validator(_.numericValue);
		}
	}
	return true;
}

export const eventPriceValidator: ValidationRule<NonValidEventPrice | EventPrice> = {
	validator: isValidEventPrice,
};

const NON_VALID_URLS = [
	null,
	undefined,
	'',
	'http://',
	EMPTY_URL,
];

export function isValidOnlineMeetingUrl(meeting: UpsertEventMeetingButton): boolean {
	if (!meeting.isEnabled) {
		return true;
	}
	return !NON_VALID_URLS.includes(meeting.videoUrl.trim());
}

export const onlineMeetingUrlValidator: ValidationRule<UpsertEventMeetingButton> = {
	validator: isValidOnlineMeetingUrl,
};

export function isValidOnlineMeetingButtonText(meeting: UpsertEventMeetingButton): boolean {
	if (!meeting.isEnabled) {
		return true;
	}
	return Boolean(meeting.videoButtonText.trim());
}

export const onlineMeetingButtonTextValidator: ValidationRule<UpsertEventMeetingButton> = {
	validator: isValidOnlineMeetingButtonText,
};
